import { openCloudFilePicker } from './openFilePicker';
import type { AttachmentMultiMenuMap } from '../types/AttachmentMultiMenuMap';
import type AttachmentMultiPicker from '../types/AttachmentMultiPicker';
import { DatapointStatus, PerformanceDatapoint } from 'owa-analytics';
import type { AttachmentMultiMenuEntry } from 'owa-attachment-multi-menu-actions';
import { lazyGetAttachmentSuggestionsTraceId } from 'owa-attachment-suggestions';
import type { ComposeViewState } from 'owa-mail-compose-store';
import { isFeatureEnabled } from 'owa-feature-flags';

export function getAttachmentClickHandlerMap(
    attachmentMultiPicker: AttachmentMultiPicker,
    viewState: ComposeViewState,
    attachmentMultiMenuEntry: AttachmentMultiMenuEntry,
    actionSource: string
): AttachmentMultiMenuMap<() => void> {
    const attachmentMultiMenuEntriesClickHandlerMap: AttachmentMultiMenuMap<() => void> = {
        computer: async () => {
            const datapoint = new PerformanceDatapoint('AttachLocalComputerClicked');
            datapoint.addCustomData([actionSource]);
            if (attachmentMultiPicker.computer.current.current) {
                attachmentMultiPicker.computer.current.current.click();
                datapoint.end();
            } else {
                datapoint.endWithError(
                    DatapointStatus.ClientError,
                    new Error('Lazy component not loaded')
                );
            }

            const getAttachmentSuggestionsTraceId = await lazyGetAttachmentSuggestionsTraceId.import();
            const traceId = getAttachmentSuggestionsTraceId(viewState.referenceItemId);
            attachmentMultiMenuEntry.computer.logUsage(actionSource, traceId);
        },
        onlineLocation: async () => {
            openCloudFilePicker(viewState, attachmentMultiPicker.targetWindow);

            const getAttachmentSuggestionsTraceId = await lazyGetAttachmentSuggestionsTraceId.import();
            const traceId = getAttachmentSuggestionsTraceId(viewState.referenceItemId);
            attachmentMultiMenuEntry.onlineLocation.logUsage(actionSource, traceId);
        },
        uploadAndShareFromCloud: async () => {
            const datapoint = new PerformanceDatapoint('AttachUploadAndSharedClicked');
            datapoint.addCustomData([actionSource]);
            if (
                (isFeatureEnabled('doc-deprecateCloudy-preview') ||
                    isFeatureEnabled('doc-deprecateCloudy-preview-thumbnailView')) &&
                attachmentMultiPicker.onlineLocation.current.current
            ) {
                attachmentMultiPicker.onlineLocation.current.current.click();
                datapoint.end();
            } else if (
                !isFeatureEnabled('doc-deprecateCloudy-preview') &&
                !isFeatureEnabled('doc-deprecateCloudy-preview-thumbnailView') &&
                attachmentMultiPicker.uploadAndShareFromCloud.current.current
            ) {
                attachmentMultiPicker.uploadAndShareFromCloud.current.current.click();
                datapoint.end();
            } else {
                datapoint.endWithError(
                    DatapointStatus.ClientError,
                    new Error('Lazy component not loaded')
                );
            }

            const getAttachmentSuggestionsTraceId = await lazyGetAttachmentSuggestionsTraceId.import();
            const traceId = getAttachmentSuggestionsTraceId(viewState.referenceItemId);
            attachmentMultiMenuEntry.uploadAndShareFromCloud.logUsage(actionSource, traceId);
        },
    };

    return attachmentMultiMenuEntriesClickHandlerMap;
}
